import PauseMonitoringCancelModal from './PauseMonitoringCancelModal';

export default PauseMonitoringCancelModal;
